import { Button } from '@mui/material';
import { useState } from 'react';
import BugReportBottomSheet from '../BugReportBottomSheet/BugReportBottomSheet';

export default function BugReport({ sx }) {
  const [showBottomSheet, setShowBottomSheet] = useState(false);

  return (
    <>
      <Button sx={{ ...sx }} onClick={() => setShowBottomSheet(true)}>ثبت گزارش مشکل</Button>
      <BugReportBottomSheet
        show={showBottomSheet}
        hideBottomSheet={() => setShowBottomSheet(false)}
      />
    </>
  );
}
